import { Box, Modal } from '@mui/material'
import { CustomColumnGridConfig } from '../types'
import ImageIcon from '../../../../../assets/ImageIcon.svg'
import { useState } from 'react'
const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'water_connection_number',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'meter_number',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'diameter',
    headerName: 'קוטר',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'measurement_zone',
    headerName: 'איזור מדידה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'consumer_name',
    headerName: 'שם הצרכן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    field:'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'payer_number',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'installation_date',
    headerName: 'ת.התקנה',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,

  },

  // NEW installation-related fields
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'bypass_bar_installation',
    headerName: 'התקנת פס גישור',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'installation_code',
    headerName: 'ק.התקנה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    flex: 1,
    field: 'meter_photo_url',
    headerName: 'צילום מד',
    filterSpec: { kind: 'none' },
    filterable: false,
    hideable: true,
    disableAggregation: true,
    renderCell: (params: any) => {
      const [openImage, setOpenImage] = useState(false)
      const handleOpenImage = () => setOpenImage(true)
      const handleCloseImage = () => setOpenImage(false)
      return (
        <Box>
          <img
            src={ImageIcon}
            alt="meter photo"
            onClick={() => handleOpenImage()}
          />
          <Modal open={openImage} onClose={handleCloseImage}>
            <Box sx={{ width: 'fit-content', marginLeft: '25%' }}>
              <img src={params.row.meter_photo_url} alt="meter photo" />
            </Box>
          </Modal>
        </Box>
      )
    },
  },
]

export default columnsConfig
